import React, { useEffect, useState } from 'react';
import { Menu, X, Instagram } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const WHATSAPP_LINK = 'https://wa.me/573054520211?text=Hola%20vengo%20desde%20la%20web%20y%20quiero%20reservar%20una%20cita';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Barberos',
    href: '#barberos'
  }, {
    name: 'Ubicación',
    href: '#ubicacion'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md py-3 shadow-md' : 'bg-transparent py-5'}`} data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="flex justify-between items-center" data-id="element-107">
          <div className="flex items-center gap-3" data-id="element-108">
            <a href="#" className="flex-shrink-0" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/qNMs9QRv4uc9izQxfDfbUw/image.png" alt="Le Barber Club" className="h-10 w-auto object-contain" data-id="element-110" />
            </a>
            <a href="https://www.instagram.com/lebarber.club/" target="_blank" rel="noopener noreferrer" className="text-brand-gray hover:text-brand-gold transition-colors" data-id="element-111">
              <Instagram className="w-5 h-5" data-id="element-112" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-113">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-light hover:text-brand-gold transition-colors text-sm font-medium tracking-wide" data-id="element-114">
                {link.name}
              </a>)}
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-gold px-6 py-2 text-sm" data-id="element-115">
              Reservar
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-brand-light hover:text-brand-gold" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-116">
            {mobileMenuOpen ? <X size={28} data-id="element-117" /> : <Menu size={28} data-id="element-118" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-119">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-dark border-t border-brand-card" data-id="element-120">
            <div className="px-4 pt-2 pb-6 space-y-4 flex flex-col" data-id="element-121">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block text-brand-light hover:text-brand-gold py-2 text-lg" data-id="element-122">
                  {link.name}
                </a>)}
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-gold px-4 py-3 text-center mt-4 block" data-id="element-123">
                Reservar
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}